import axios from 'axios';
 
import { PUBLIC_URLS } from './PublicUrl';
import Notifier from '../../../Utils/notify';
import Session from '../Utills/Session';
 

axios.interceptors.request.use(function (config) {

    config.headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
         ...config.headers
    }
     // ✅ Only attach token if explicitly allowed
    if (config.requireAuth !== false && isRequireToken(config.url)) {
        const token = Session.get('token_arct');
        if (token) {
            config.headers["Authorization"] = `Token ${token}`;
        }
    }

    return config;
}, function (error) {
    return Promise.reject(error);
})

// Add a response interceptor
axios.interceptors.response.use(function (response) {

    // Do something with response data 
    // 200 OR 20*
    // SUCESS: if request by PUT/POST/DELETE
    // SUCESS: and GET request : no notification
    // ERROR: always

    return response.data;

}, function (error) {
    console.log("error", error);
    if (!error.response && error.message === 'Network Error') {
        return Promise.reject("Couldn't connect to server. Please try again later.");
    } else if (error.response && error.response.data.statusCode === 401) {
        // store.dispatch(logOut());
        // store.dispatch(removeToken());
    } else if (error.response && error.response.data) {
        return Promise.reject(error.response.data);
    } else {
        return Promise.reject("Server Connection Failed");
    }
});

export default class HTTP {
    static Request(method, url, data = null,options={}) {

        return new Promise((resolve, reject) => {
            const request = {
                method,
                url,
                [method.toUpperCase() === 'GET' ? "params" : "data"]: data,
                headers: {
                    'Content-Type': 'application/json'
                },
                 ...options // 👈 allow requireAuth flag

            };
            axios(request)
                .then(response => resolve(response))
                .catch(error => {
                    console.log("error is interceptors",error)
                    if (error.errors) {
                        Notifier.error(error.errors[0]);
                    } else {
                        Notifier.error(error);
                    }
                    reject(error)
                }
                );
        });
    }
}

function isRequireToken(url) {
    const match = PUBLIC_URLS.filter(u => url.endsWith(u));
    return match.length === 0;
}